import API_BASE from '../../../utils/api.js';

// The support-admin catalog import endpoints. The server only answers verified
// SUPPORT_ADMIN_EMAILS addresses, and every write lands in the studio named in
// the URL.
const BASE = `${API_BASE}/api/support-admin/catalog-import`;

export async function request(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(data?.error || `Request failed (${res.status})`), {
      status: res.status,
    });
  }
  return data;
}

export const studioLabel = (studio) =>
  studio.companyName || studio.ownerName || studio.email || studio.userId;

export const listStudios = () => request('/accounts');

export function studioImportApi(userId) {
  const account = `/accounts/${encodeURIComponent(userId)}`;
  const product = (itemId) => `${account}/products/${encodeURIComponent(itemId)}`;
  return {
    loadContext: () => request(account),
    createProduct: (payload) => request(`${account}/products`, { method: 'POST', body: payload }),
    updateProduct: (itemId, payload) => request(product(itemId), { method: 'PUT', body: payload }),
    deleteProduct: (itemId) => request(product(itemId), { method: 'DELETE' }),
    // Both reuse the studio's existing vendor or category when the name matches.
    ensureVendor: (name) => request(`${account}/vendors`, { method: 'POST', body: { name } }),
    ensureCategory: (name, type) =>
      request(`${account}/categories`, { method: 'POST', body: { name, type } }),
    // Copies a photo the import file links to into the studio's uploads.
    copyImage: (url) => request(`${account}/images`, { method: 'POST', body: { url } }),
  };
}
